/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import ActionCard from "./actionCard";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../../redux/Reducer";
import { GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS } from "../../../../redux/Action/actionTypes";

const PreparationOverview = ({ currentStep,isEditDisabled }: { currentStep: number,isEditDisabled:boolean }) => {
  const [preparationActionCards, setPreparationActionCards] = useState<
    object[]
  >([]);
  const negotiationContractData = useSelector(
    (state: RootState) => state.dashboardData.detailedOverviewData
  );
 
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (Object.keys(negotiationContractData).length > 0) {
      let preparationArr: any = [];
      negotiationContractData.planNegotiationActions.negotiationRoundsDetails
        .length &&
        negotiationContractData.planNegotiationActions.negotiationRoundsDetails.map(
          (data: any) => {
            if (data.roundName === "Preparation") {
              preparationArr = data.selectedAction;
            }
          }
        );
      setPreparationActionCards(preparationArr);
    }
  }, [negotiationContractData,currentStep]);

  const handleCheckboxChange = (id: string) => {
    setPreparationActionCards((prevCardArr) =>
      prevCardArr.map((item: any) =>
        item.id === id
          ? { ...item, isNegotiationActionUsed: !item.isNegotiationActionUsed }
          : item
      )
    );
    negotiationContractData.planNegotiationActions.negotiationRoundsDetails
      .length &&
      negotiationContractData.planNegotiationActions.negotiationRoundsDetails.map(
        (data: any) => {
          if (data.roundName === "Preparation") {
            let newArr: any = [];
            newArr =
              data.selectedAction.length &&
              data.selectedAction.map((item: any) =>
                item.id === id
                  ? {
                    ...item,
                    isNegotiationActionUsed: !item.isNegotiationActionUsed,
                  }
                  : item
              );
            data.selectedAction = newArr;
          }
        }
      );
    dispatch({
      type: GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS,
      payload: negotiationContractData,
    });
  };

  const handleInputChange = (cardId: string, value: string) => {
    const updatedCards = preparationActionCards.map((item: any) =>
      item.id === cardId ? { ...item, implementationApproach: value } : item
    );
    setPreparationActionCards(updatedCards);
    const updatedData = { ...negotiationContractData };
    updatedData.planNegotiationActions.negotiationRoundsDetails = updatedData.planNegotiationActions.negotiationRoundsDetails.map(
      (round: any) =>
        round.roundName === "Preparation"
          ? {
              ...round,
              selectedAction: round.selectedAction.map((item: any) =>
                item.id === cardId
                  ? { ...item, implementationApproach: value }
                  : item
              ),
            }
          : round
    );
    dispatch({
      type: GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS,
      payload: updatedData,
    });
  };
 
  return (
    <div className="preparation-actions-overview">
      <div className="preparation-actions-overview-heading">
        Preparation actions :
      </div>
      <div className="row">
        {preparationActionCards.length > 0 ? (
          preparationActionCards.map((data: any, index: number) => {
            return (
              <ActionCard
                key={data.id}
                contractData={data}
                handleCheckboxChange={handleCheckboxChange}
                isEditDisabled={isEditDisabled}
                onInputChange={(value) => handleInputChange(data.id, value)}
              />
            );
          })
        ) : (
          <div className="negotiation-no-data-message">
            Plan Negotiation Actions are not available.
          </div>
        )}
      </div>
    </div>
  );
};

export default PreparationOverview;
